/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Animated,
  StyleProp,
  ViewStyle,
  TextStyle,
} from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE"></desc>
 * <g id="AttachmentIcon">
 * <path id="Vector" d="M1.61242 15.527C0.119787 14.6045 -0.437279 12.6354 0.370632 11.1375L5.28719 2.02214C6.36441 0.0249629 8.85993 -0.599232 10.8501 0.630709C12.8403 1.86065 13.583 4.48612 12.5058 6.4833L7.58926 15.5987L6.68694 15.041L11.6035 5.92565C12.4114 4.42777 11.8543 2.45867 10.3617 1.53621C8.86907 0.613755 6.99743 1.0819 6.18952 2.57978L1.27296 11.6952C0.734354 12.6938 1.10573 14.0065 2.10082 14.6215C3.09591 15.2364 4.34367 14.9243 4.88228 13.9258L8.82204 6.62137C9.09134 6.12207 8.90565 5.46571 8.40811 5.15822C7.91056 4.85073 7.28668 5.00678 7.01738 5.50608L3.07762 12.8105L2.17529 12.2528L6.11505 4.94843C6.65366 3.94984 7.90142 3.63775 8.89651 4.25272C9.8916 4.86769 10.263 6.18042 9.72437 7.17901L5.78461 14.4834C4.9767 15.9813 3.10505 16.4494 1.61242 15.527Z" fill="#373938"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {}
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const AttachmentIcon = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    svgRef,
  } = props;
  /** End Custom React-Hooks */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 13 16" fill="none" id="svg_root" ref={svgRef} {...props}>
      <G id="AttachmentIcon">
        <Path
          id="Vector"
          d="M1.61242 15.527C0.119787 14.6045 -0.437279 12.6354 0.370632 11.1375L5.28719 2.02214C6.36441 0.0249629 8.85993 -0.599232 10.8501 0.630709C12.8403 1.86065 13.583 4.48612 12.5058 6.4833L7.58926 15.5987L6.68694 15.041L11.6035 5.92565C12.4114 4.42777 11.8543 2.45867 10.3617 1.53621C8.86907 0.613755 6.99743 1.0819 6.18952 2.57978L1.27296 11.6952C0.734354 12.6938 1.10573 14.0065 2.10082 14.6215C3.09591 15.2364 4.34367 14.9243 4.88228 13.9258L8.82204 6.62137C9.09134 6.12207 8.90565 5.46571 8.40811 5.15822C7.91056 4.85073 7.28668 5.00678 7.01738 5.50608L3.07762 12.8105L2.17529 12.2528L6.11505 4.94843C6.65366 3.94984 7.90142 3.63775 8.89651 4.25272C9.8916 4.86769 10.263 6.18042 9.72437 7.17901L5.78461 14.4834C4.9767 15.9813 3.10505 16.4494 1.61242 15.527Z"
          fill="#373938"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </G>
    </Svg>
  );
};
/***/

export default React.memo(AttachmentIcon);
